<template>
	<div >
		<el-input size="small" v-model="value" @input="updateValue" :placeholder="'请输入' + info.fieIdName" :rows="4"  :label="info.fieIdName"  type="textarea"></el-input>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			value: null
			}
		},
		props: ['info','index'],
		mounted() {
			this.$nextTick(()=>{
				this.value = this.info.fieIdValue ? this.info.fieIdValue : null
			})
		},
		methods: {
			updateValue(e){
				let obj = {
					type: 1,
					fieIdValue: this.value,
					fieIdId: this.info.fieIdId,
					index: this.index
				}
				this.$emit('updateValue',obj)
			}
		}
	}
</script>